import { Box, Button, Stack, Typography } from "@mui/material";
import { COLORS } from "assets";
import { ReactNode } from "react";

export const bulkCheckboxSx = {
  p: 0.5,
  color: COLORS.surface.mutedText,
  "&.Mui-checked": { color: COLORS.primary },
  "&.MuiCheckbox-indeterminate": { color: COLORS.primary }
};

export const bulkPrimaryButtonSx = {
  height: 40,
  minHeight: 40,
  px: 2.25,
  borderRadius: `${COLORS.radius.sm}px`,
  textTransform: "none" as const,
  fontWeight: 500,
  fontSize: 14,
  lineHeight: 1.2,
  boxShadow: "none",
  color: `${COLORS.white} !important`,
  backgroundImage: "none !important",
  backgroundColor: `${COLORS.primary} !important`,
  "&:hover": {
    backgroundImage: "none !important",
    backgroundColor: `${COLORS.primary} !important`,
    filter: "brightness(1.06)",
    boxShadow: "none"
  }
};

export const bulkDeleteButtonSx = {
  height: 40,
  minHeight: 40,
  px: 2.25,
  borderRadius: `${COLORS.radius.sm}px`,
  textTransform: "none" as const,
  fontWeight: 500,
  fontSize: 14,
  lineHeight: 1.2,
  boxShadow: "none",
  color: `${COLORS.white} !important`,
  backgroundImage: "none !important",
  backgroundColor: `${COLORS.error} !important`,
  "&:hover": {
    backgroundImage: "none !important",
    backgroundColor: `${COLORS.error} !important`,
    filter: "brightness(1.05)",
    boxShadow: "none"
  }
};

export interface BulkActionBarProps {
  count: number;
  label: string;
  onClear: () => void;
  clearLabel: string;
  children?: ReactNode;
}

export default function BulkActionBar({ count, label, onClear, clearLabel, children }: BulkActionBarProps) {
  if (count <= 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        flexWrap: "wrap",
        px: 2,
        py: 1.25,
        mb: 2,
        borderRadius: `${COLORS.radius.md}px`,
        bgcolor: COLORS.surface.selection
      }}
    >
      <Typography sx={{ color: COLORS.primary, fontWeight: 600, fontSize: 14, lineHeight: 1.4 }}>
        {count} {label}
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center">
        {children}
        <Button
          type="button"
          variant="outlined"
          onClick={onClear}
          sx={{
            height: 40,
            minHeight: 40,
            px: 2.25,
            borderRadius: `${COLORS.radius.sm}px`,
            border: `1px solid ${COLORS.surface.border}`,
            borderColor: COLORS.surface.border,
            color: COLORS.surface.secondaryText,
            fontWeight: 500,
            fontSize: 14,
            lineHeight: 1.2,
            textTransform: "none",
            backgroundImage: "none",
            backgroundColor: COLORS.surface.card,
            boxShadow: "none",
            "&:hover": {
              borderColor: COLORS.surface.secondaryText,
              backgroundColor: COLORS.surface.card,
              backgroundImage: "none"
            }
          }}
        >
          {clearLabel}
        </Button>
      </Stack>
    </Box>
  );
}
